import {
  comparePivotRowsByDimension,
  getPivotMetricNumeric,
  type LogisticPivotDimension,
  type LogisticPivotMetricColumnId,
  type LogisticPivotRow,
} from '../models/LogisticPivot';

export type PivotSortKey =
  | `dim:${LogisticPivotDimension}`
  | `metric:${LogisticPivotMetricColumnId}`;

export function comparePivotRows(
  a: LogisticPivotRow,
  b: LogisticPivotRow,
  sortKey: PivotSortKey,
  direction: 'asc' | 'desc'
): number {
  const mult = direction === 'asc' ? 1 : -1;

  if (sortKey.startsWith('dim:')) {
    const dim = sortKey.slice(4) as LogisticPivotDimension;
    return comparePivotRowsByDimension(a, b, dim) * mult;
  }

  if (sortKey.startsWith('metric:')) {
    const id = sortKey.slice(7) as LogisticPivotMetricColumnId;
    return (getPivotMetricNumeric(a, id) - getPivotMetricNumeric(b, id)) * mult;
  }

  return 0;
}

export function sortPivotRows(
  rows: LogisticPivotRow[],
  sortKey: PivotSortKey,
  direction: 'asc' | 'desc'
): LogisticPivotRow[] {
  if (rows.length <= 1) return [...rows];
  const copy = [...rows];
  copy.sort((a, b) => comparePivotRows(a, b, sortKey, direction));
  return copy;
}
